import { svg } from 'lit';

const symbol = svg`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none"><path d="M14.5 11.5L8 5l-6.6 6.5z" stroke-linecap="round" fill="currentcolor" stroke-linejoin="round" filter="none"/></svg>`;

export { symbol as default };
